"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MfaTexteRadioBoutonHorizonBase = exports.separateur = void 0;

var _react = _interopRequireWildcard(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _utilitaires = require("../utils/utilitaires");

require("../css/mfa-texte-radio-bouton-horizon.css");

require("../css/mfa-radio-boutons.css");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var separateur = ";%";
exports.separateur = separateur;

var MfaTexteRadioBoutonHorizonBase = /*#__PURE__*/function (_Component) {
  _inherits(MfaTexteRadioBoutonHorizonBase, _Component);

  var _super = _createSuper(MfaTexteRadioBoutonHorizonBase);

  function MfaTexteRadioBoutonHorizonBase(props) {
    var _this;

    _classCallCheck(this, MfaTexteRadioBoutonHorizonBase);

    _this = _super.call(this, props);
    _this.state = {
      choix: '',
      valeur: '',
      nomRadio: _this.props.nomRadio,
      nomTexte: _this.props.nomTexte,
      longueurMaximale: _this.props.longueurMaximale,
      valeurInitiale: _this.props.valeurInitiale,
      etiquetteEmplacement: _this.props.etiquetteEmplacement
    };
    _this.surSaisie = _this.surSaisie.bind(_assertThisInitialized(_this));
    _this.surClique = _this.surClique.bind(_assertThisInitialized(_this));
    _this.surChangement = _this.surChangement.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MfaTexteRadioBoutonHorizonBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var nomTexte = 'Texte' + this.props.nomGroupe;

      if ((0, _utilitaires.nestPasNulOuVide)(this.props.nomRadio)) {
        nomTexte = this.props.nomTexte + this.props.nomGroupe;
      }

      var nomRadio = 'Radio' + this.props.nomGroupe;

      if ((0, _utilitaires.nestPasNulOuVide)(this.props.nomRadio)) {
        nomRadio = this.props.nomRadio + this.props.nomGroupe;
      }

      var longueurMaximale = 50;

      if ((0, _utilitaires.nestPasNulOuVide)(this.props.longueurMaximale)) {
        longueurMaximale = this.props.longueurMaximale;
      }

      var valeurTexte = [];

      if ((0, _utilitaires.nestPasNulOuVide)(this.props.valeurInitiale)) {
        valeurTexte = this.props.valeurInitiale.split(separateur);
      }

      var valeur = '';
      var choix = '';

      if (valeurTexte.length > 1) {
        valeur = valeurTexte[0];
        choix = valeurTexte[1];
      }

      this.setState({
        nomTexte: nomTexte,
        nomRadio: nomRadio,
        longueurMaximale: longueurMaximale,
        valeur: valeur,
        choix: choix
      }, function () {});
    }
  }, {
    key: "surChangement",
    value: function surChangement(event) {}
  }, {
    key: "surSaisie",
    value: function surSaisie(event) {
      if ((0, _utilitaires.estDefini)(this.props.regleValidationSaisie)) {
        if (!event.target.validity.valid) {
          return false;
        }
      }

      var value = event.target.value;
      this.setState({
        valeur: value
      });

      if ((0, _utilitaires.estDefini)(this.props.surChangement)) {
        var valeur = value + separateur + this.state.choix;
        this.props.surChangement(valeur);
      }
    }
  }, {
    key: "surClique",
    value: function surClique(event) {
      var value = event.target.value;
      this.setState({
        choix: value
      });

      if ((0, _utilitaires.estDefini)(this.props.surChangement)) {
        var valeur = this.state.valeur + separateur + value;
        this.props.surChangement(valeur);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "d-flex flex-wrap align-items-center justify-content-start"
      }, this.afficherSaisieTexte() && /*#__PURE__*/_react.default.createElement("input", {
        type: "text",
        className: "mfa-texte",
        id: this.state.nomTexte,
        name: this.state.nomTexte,
        maxLength: this.state.longueurMaximale,
        value: this.state.valeur,
        pattern: (0, _utilitaires.estDefini)(this.props.regleValidationSaisie) ? this.props.regleValidationSaisie : '',
        onInput: function onInput(event) {
          return _this2.surSaisie(event);
        },
        onChange: function onChange(event) {
          return _this2.surChangement(event);
        },
        style: {
          width: '15%'
        }
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "d-block"
      }, this.props.donnees.map(function (donnee, index) {
        return /*#__PURE__*/_react.default.createElement("label", {
          className: "label-radio",
          key: _this2.state.nomRadio + index.toString(),
          htmlFor: _this2.state.nomRadio + index.toString(),
          style: {
            marginLeft: '1rem',
            marginBottom: '0'
          }
        }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Radio, {
          key: _this2.state.nomRadio + index.toString(),
          type: "radio",
          id: _this2.state.nomRadio + index.toString(),
          name: _this2.props.groupe,
          value: donnee.valeur,
          checked: _this2.state.choix === donnee.valeur,
          disabled: donnee.desactive,
          onChange: function onChange(event) {
            return _this2.surClique(event);
          },
          style: {
            marginRight: '0.5rem'
          }
        }), " ", donnee.etiquette);
      })));
    }
  }, {
    key: "afficherSaisieTexte",
    value: function afficherSaisieTexte() {
      if (!(0, _utilitaires.nestPasNulOuVide)(this.props.texteEstVisible)) {
        return true;
      }

      return this.props.texteEstVisible === true;
    }
  }]);

  return MfaTexteRadioBoutonHorizonBase;
}(_react.Component);

exports.MfaTexteRadioBoutonHorizonBase = MfaTexteRadioBoutonHorizonBase;